import styled from 'styled-components';
import {dFlex, dFlexBetween, dFlexColumn} from '../../../../../globalVariables/GlobalFlex';
import {mobileMedia} from '../../../../../globalVariables/GlobalVariables';

export const formBlock = styled.div`
    ${dFlexColumn};
    padding: var(--space-xl) var(--space-lg);
    gap: var(--space-xl);
    max-height: 100%;
    overflow: auto;
`;

export const footer = styled.div`
    ${dFlexBetween};
    padding: var(--space-lg);
    border-top: 1px solid var(--color-border-subtle);
    ${mobileMedia}{
        padding: var(--space-md);
    }
`;

export const footerButtons = styled.div`
    ${dFlex};
    gap: var(--space-md);
`;

export const stepSegmentsWrap = styled.div<{$isSuccess: boolean}>`
    width: 100%;
    &>div {
        max-width: 100%;
    }
    ${p => p.$isSuccess && `
        pointer-events: none;
        cursor: not-allowed;
    `}
`;
